export default __webpack_public_path__ + "static/media/icon-phone.43c05d1a.svg";